import React from "react";
import PropTypes from "prop-types";
import MaterialFormControlLabel from "@material-ui/core/FormControlLabel";
import {withStyles} from "@material-ui/core";

const materialStyles = {
  root: {
    "margin": `0`,
    "borderRadius": `6px`,
    "border": `solid 1px #dfe0e0`,
    "backgroundColor": `#fff`,

    "&:hover": {
      borderColor: `#c9cbcc`
    }
  },
  disabled: {
    "cursor": `not-allowed !important`,
    "opacity": `0.5`,
    "&:hover": {
      borderColor: `#dfe0e0`
    }
  }
};

function FromControlLabel(props) {
  const {control, value, label, classes, ...rest} = props;
  return (
    <MaterialFormControlLabel
      classes={{root: classes.root, disabled: classes.disabled}}
      value={value}
      control={control}
      label={label}
      {...rest}
    />
  );
}

FromControlLabel.propTypes = {
  classes: PropTypes.object,
  control: PropTypes.element,
  value: PropTypes.string,
  label: PropTypes.element
};

export default withStyles(materialStyles)(FromControlLabel);
